var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.791016,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7501 16.1489H8.69031L7.14576 10.083C7.07245 9.80397 6.91679 9.55729 6.68782 9.44103C6.11639 9.14886 5.48672 8.91633 4.7998 8.79906V8.56552H8.11789C8.57583 8.56552 8.91929 8.91633 8.97653 9.32375L9.77793 13.6993L11.8367 8.56552H13.8392L10.7501 16.1489ZM14.984 16.1489H13.0388L14.6406 8.56552H16.5858L14.984 16.1489ZM19.1025 10.6663C19.1597 10.2579 19.5032 10.0244 19.9039 10.0244C20.5336 9.96573 21.2195 10.083 21.7919 10.3742L22.1354 8.74143C21.5629 8.5079 20.9333 8.39062 20.3619 8.39062C18.4738 8.39062 17.1 9.44103 17.1 10.8989C17.1 12.0079 18.0731 12.5902 18.7601 12.941C19.5032 13.2908 19.7894 13.5244 19.7322 13.8742C19.7322 14.3989 19.1597 14.6324 18.5883 14.6324C17.9014 14.6324 17.2145 14.4575 16.5858 14.1653L16.2424 15.7991C16.9293 16.0902 17.6724 16.2075 18.3594 16.2075C20.4763 16.2651 21.7919 15.2157 21.7919 13.6406C21.7919 11.6571 19.1025 11.5408 19.1025 10.6663ZM28.5998 16.1489L27.0553 8.56552H25.3962C25.0528 8.56552 24.7093 8.79906 24.5948 9.14886L21.7347 16.1489H23.7372L24.1369 15.0408H26.5973L26.8263 16.1489H28.5998ZM25.6824 10.6077L26.2539 13.4657H24.6521L25.6824 10.6077Z",
    fill: "#172B85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.791016,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.c914b3d859bed22a6c51e7598c3d4ed7.svg";
export { ForwardRef as ReactComponent };